import React from 'react';

export default function DestinationCard({ destination, language }) {
  return (
    <div className="relative group h-72 w-full overflow-hidden rounded-3xl m-0 p-0">
      <img
        src={destination.image}
        alt={language === 'en' ? destination.title : destination.title_es}
        className="w-full h-full object-cover group-hover:scale-105 hover:brightness-125 transition-transform duration-700"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[rgba(24,28,36,0.18)] group-hover:bg-[rgba(24,28,36,0.10)] transition-colors duration-300" />
      <div className="absolute bottom-0 left-0 right-0 text-white z-30 flex flex-col items-start m-0 px-6 pb-6 pt-0">
        <h3 className="text-xl font-playfair mb-1 drop-shadow-[0_2px_12px_rgba(24,28,36,0.9)] text-[#e3c27b] font-semibold">
          {language === 'en' ? destination.title : destination.title_es}
        </h3>
        <p className="text-base mb-2 font-light drop-shadow-[0_1px_8px_rgba(24,28,36,0.8)]">
          {language === 'en' ? destination.desc : destination.desc_es}
        </p>
      </div>
    </div>
  );
} 